module.exports = __webpack_public_path__ + "img/mao02.19000cde.svg";